import React from "react";
import { motion } from "framer-motion";
import { Plane, Building2, GraduationCap, Stethoscope, ShoppingBag, Banknote, TrendingUp } from "lucide-react";

const results = [
  { Icon: Plane, industry: "Travel Industry", stat: "38%", outcome: "higher enquiry conversions" },
  { Icon: Building2, industry: "Real Estate", stat: "3×", outcome: "faster site visit scheduling" },
  { Icon: GraduationCap, industry: "Education", stat: "92%", outcome: "fee reminder delivery success" },
  { Icon: Stethoscope, industry: "Healthcare", stat: "65%", outcome: "reduction in manual follow-ups" },
  { Icon: ShoppingBag, industry: "Ecommerce", stat: "↑", outcome: "higher repeat purchases through automation" },
  { Icon: Banknote, industry: "Finance", stat: "⏱", outcome: "faster document collection and customer responses" },
];

export const Results = () => {
  return (
    <section className="py-20 sm:py-28 bg-slate-50 overflow-hidden" data-testid="results-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-emerald-600 flex items-center gap-2">
            <TrendingUp className="h-3.5 w-3.5" /> Business impact
          </p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
            Real Business Results on WhatsApp
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Outcomes Wappit customers consistently see after going live with the official WhatsApp Business API.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {results.map(({ Icon, industry, stat, outcome }, i) => (
            <motion.div
              key={industry}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`result-card-${industry.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-3xl border border-slate-200 bg-white p-7 hover:shadow-xl hover:-translate-y-0.5 transition-all"
            >
              <div className="flex items-center justify-between">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-blue-700 ring-4 ring-blue-100">
                  <Icon className="h-5 w-5" />
                </div>
                <span className="text-xs font-bold uppercase tracking-wider text-slate-500">{industry}</span>
              </div>
              <div className="mt-6 flex items-end gap-2">
                <span className="text-4xl sm:text-5xl font-extrabold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
                  {stat}
                </span>
              </div>
              <p className="mt-1 text-slate-700 text-[15px] leading-relaxed">{outcome}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-xs text-slate-500">
          Results based on average outcomes reported by Wappit customers across the relevant industry. Individual results may vary.
        </p>
      </div>
    </section>
  );
};
